import { JobProgress } from '@commenda/pathfinder';

import { useDocumentReadingRunStrip } from './useDocumentReadingRunStrip';

interface DocumentReadingRunStripProps {
  runId: string;
  /** True for a run started after the chat opened, which shows even if it settled before its first look. */
  isNewInSession: boolean;
}

/** One reading run above the composer as Pathfinder's JobProgress. No buttons: notify and cancel wait
 * for backend support, and the chat stays usable while the run goes on. */
export function DocumentReadingRunStrip({
  runId,
  isNewInSession,
}: Readonly<DocumentReadingRunStripProps>) {
  const { stripView, isVisible, onExited } = useDocumentReadingRunStrip(
    runId,
    isNewInSession
  );

  if (!stripView) return null;

  return (
    <JobProgress
      state={stripView.state}
      title={stripView.title}
      detail={stripView.detail ?? undefined}
      progress={stripView.progress}
      progressLabel={stripView.progressLabel}
      visible={isVisible}
      onExited={onExited}
    />
  );
}
